export const SIDEBAR_ROLE_KEYS = ['agent', 'administrator'];

const normalizeHiddenMenus = hiddenMenus => {
  if (!hiddenMenus || typeof hiddenMenus !== 'object') return {};

  return SIDEBAR_ROLE_KEYS.reduce((acc, role) => {
    acc[role] = Array.isArray(hiddenMenus[role])
      ? hiddenMenus[role].filter(Boolean).map(String)
      : [];
    return acc;
  }, {});
};

const menuPath = (item, parents = []) => [...parents, item.name].join('/');

const isHiddenForRole = ({ item, parents, role, hiddenMenusByRole }) => {
  const accountHiddenMenus = hiddenMenusByRole[role] || [];
  const menuPaths = parents.reduce((paths, parent, index) => {
    paths.push(parents.slice(0, index + 1).join('/'));
    return paths;
  }, []);

  return (
    menuPaths.some(path => accountHiddenMenus.includes(path)) ||
    accountHiddenMenus.includes(menuPath(item, parents))
  );
};

export const isMenuHiddenForRole = ({
  name,
  role,
  hiddenMenus,
  isSuperAdmin = false,
  parents = [],
}) => {
  if (isSuperAdmin) return false;

  return isHiddenForRole({
    item: { name },
    parents,
    role,
    hiddenMenusByRole: normalizeHiddenMenus(hiddenMenus),
  });
};

export const filterSidebarMenusForRole = ({
  items,
  role,
  hiddenMenus,
  isSuperAdmin = false,
  parents = [],
}) => {
  if (isSuperAdmin) return items;

  const hiddenMenusByRole = normalizeHiddenMenus(hiddenMenus);

  return items
    .filter(item => {
      if (isHiddenForRole({ item, parents, role, hiddenMenusByRole })) {
        return false;
      }

      return true;
    })
    .map(item => {
      if (!item.children) return item;

      const children = filterSidebarMenusForRole({
        items: item.children,
        role,
        hiddenMenus: hiddenMenusByRole,
        isSuperAdmin,
        parents: [...parents, item.name],
      });

      return { ...item, children };
    });
};
